import Title from "../dashboard/Title";
import * as React from "react";
import { Device, useDeleteDeviceMutation } from "../../store/apis/devicesApi";
import Grid from "@mui/material/Grid";
import { DeviceCard } from "./DeviceCard";
import { useState } from "react";
import { AddDeviceForm } from "./AddDeviceForm";
import { setSelectionRange } from "@testing-library/user-event/event/selection/setSelectionRange";
import { useLoadLatestTempDataQuery } from "../../store";

export const SavedDevices = ({
  savedDevices,
  updateDevice
}: {
  savedDevices: Device[];
  updateDevice: (dev: Device) => void;
}) => {
  const [deleteSensor, deleteSensorResult] = useDeleteDeviceMutation();
  const [selectedDevice, setSelectedDevice] = useState<Device>();
  const { data } = useLoadLatestTempDataQuery(null);
  const remove = (id: number) => {
    deleteSensor(id);
  };

  const renderSensors = () => {
    if (!savedDevices.length) {
      return <div>Ei tallennettuja laitteita.</div>;
    } else {
      return (
        <Grid container spacing={1}>
          <AddDeviceForm
            handleAddClose={() => setSelectedDevice(undefined)}
            handleAddDevice={updateDevice}
            handleRemoveDevice={deleteSensor}
            open={Boolean(selectedDevice)}
            device={selectedDevice}
          />
          {savedDevices.map(dev => (
            <DeviceCard
              device={dev}
              key={dev.id}
              handleEdit={dev => setSelectedDevice(dev)}
            />
          ))}
        </Grid>
      );
    }
  };

  return (
    <>
      <Title>Laitteet</Title>
      {renderSensors()}
    </>
  );
};
